import { useState } from "react";

/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { Heading, Paragraph } from "../UI/Typoraphy";

import { mq } from "../responsive";
import Cart from "../../assets/cart.svg";
import { Flex } from "../shared";

import { useHistory } from "react-router";

const ProductCard = ({ data }) => {
  const { title, price, location, rating, wished, image, slug } = data;
  const [isWished, setWished] = useState(wished);

  const _handleWishClick = (e) => {
    setWished((isWished) => !isWished);
    // Call API
  };

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const history = useHistory();

  const handleCardClick = () => history.push(`/detail/${slug}`);

  return (
    <div
      css={{
        borderRadius: "2rem",
        boxShadow: "0 6px 14px rgba(0, 0, 0, 0.08)",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        height: "18rem",
        width: "100%",
        cursor: "pointer",

        [mq.md]: {
          height: "35rem",
        },
      }}
      onClick={handleCardClick}
    >
      <span
        css={{
          position: "absolute",
          top: "2rem",
          left: "2rem",
          cursor: "pointer",
          zIndex: 1,
        }}
        onClick={_handleWishClick}
      >
        {isWished ? (
          <i
            className="fas fa-heart"
            style={{ fontSize: "3rem", color: "#ff794b" }}
          ></i>
        ) : (
          <i
            className="far fa-heart"
            style={{ fontSize: "3rem", color: "#ff794b" }}
          ></i>
        )}
      </span>
      <figure
        css={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          width: "14rem",
          minWidth: "14rem",
          borderRadius: "2rem",
          position: "relative",

          "&:before": {
            content: `""`,
            position: "absolute",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(255,255,255,0) 40%)",
          },

          [mq.md]: {
            width: "30rem",
            minWidth: "30rem",
          },
        }}
      >
        <img
          src={image}
          alt={title}
          css={{
            height: "100%",
            width: "100%",
          }}
        />
      </figure>

      <div
        css={{
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          flexGrow: 2,
          position: "relative",

          [mq.md]: {
            justifyContent: "flex-start",
            paddingTop: "8rem",
          },
        }}
      >
        <Heading
          level={3}
          style={{
            fontWeight: 500,
            lineHeight: "3rem",
            fontSize: "2rem",
            height: "6rem",

            [mq.md]: {
              fontSize: "3rem",
              lineHeight: "4.5rem",
              height: "9rem",
            },
          }}
        >
          {title}
        </Heading>

        <Flex css={{ justifyContent: "space-between" }}>
          <Paragraph
            style={{
              [mq.md]: {
                position: "absolute",
                top: "4rem",
              },
            }}
          >
            <i
              className="fas fa-map-marker-alt"
              style={{ marginRight: "1rem" }}
            ></i>
            {location}
          </Paragraph>
          <Paragraph
            style={{
              [mq.md]: {
                position: "absolute",
                bottom: "3rem",
                right: "3rem",
              },
            }}
          >
            {formatter.format(price)}
          </Paragraph>
        </Flex>
        <Paragraph
          style={{
            display: "none",
            [mq.md]: {
              fontSize: "2rem",
              lineHeight: "3rem",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            },
          }}
        >
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, eum
          nemo? In aut architecto animi nisi asperiores quisquam eligendi
          facilis assumenda! Dicta distinctio commodi tenetur, beatae
          dignissimos molestiae possimus necessitatibus?
        </Paragraph>
        <Flex
          css={{
            position: "absolute",
            alignItems: "center",
            bottom: "2rem",
            [mq.md]: {
              bottom: "3rem",
            },
          }}
        >
          <i
            className="fas fa-star"
            css={{
              fontSize: "2rem",
              width: "2rem",
              color: "#ffd010",
              marginRight: "1rem",
              marginBottom: "0.5rem",
            }}
          ></i>
          <Paragraph>{rating}</Paragraph>
        </Flex>
        <img
          src={Cart}
          alt="add to cart"
          css={{
            position: "absolute",
            bottom: "2rem",
            right: "2rem",
            cursor: "pointer",

            [mq.md]: {
              top: "3rem",
              right: "3rem",
            },
          }}
        />
      </div>
    </div>
  );
};

export default ProductCard;
